var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasBadge)?_c('div',{staticClass:"icon-with-badge"},[(_vm.showBadge)?_c('span',{staticClass:"badge badge-without-icon"}):_vm._e(),(_vm.badgeIcon)?_c('span',{staticClass:"badge badge-with-icon"},[_c('SvgIcon',{attrs:{"name":_vm.badgeIcon}})],1):_vm._e(),_c('SvgIcon',{attrs:{"name":_vm.name}})],1):_c('SvgIcon',{attrs:{"name":_vm.name}})
}
var staticRenderFns = []

export { render, staticRenderFns }